<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم:</label>
          <div>{{ (dataRow.Provider)? dataRow.Provider.name : 'غير معروف' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم الجوال:</label>
          <div>{{ (dataRow.Provider)? dataRow.Provider.mobile : 'غير معروف' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الوصف:</label>
          <div>{{ dataRow.title }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">النوع:</label>
          <div>{{ transactionsTypes[dataRow.transType] }}</div>
        </div>
      </div>

      <div v-if="dataRow.ProvidersBank" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم البنك:</label>
            <div>{{ (dataRow.ProvidersBank.BankAccount)? dataRow.ProvidersBank.BankAccount.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم صاحب الحساب:</label>
            <div>{{ dataRow.ProvidersBank.name }}</div>
          </div>
        </div>

        <div v-if="dataRow.ProvidersBank" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الحساب:</label>
            <div>{{ dataRow.ProvidersBank.iban }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">العنوان:</label>
            <div>{{ dataRow.ProvidersBank.address1 }}</div>
            <div>{{ dataRow.ProvidersBank.address2 }}</div>
          </div>
        </div>
      
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رقم طلب الصيانة إن وجد:</label>
          <div>{{ dataRow.orderId }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الطلب:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الطلب:</label>
          <div>{{ statusChoices[status] }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'PTransactionsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
    transactionsTypes: {
      type: Object,
      default: {},
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
    }
  },
  methods: {
    formatDate,
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
